import React, { useState } from 'react'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Divider, message, Popconfirm, Tooltip } from 'antd'

import EditReportDetailModal from './EditReportDetailModal'
import ListItemCard from '../../../components/ListItemCard'

import { deleteReportDetail } from '../services'
import { handleError } from '../../../helpers'

export default function ReportDetailCard({ reportDetail, reload }) {
	const [showEditModal, setShowEditModal] = useState(false)

	const handleDelete = () => {
		deleteReportDetail(reportDetail.id)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(handleError)
	}

	return (
		<React.Fragment>
			<ListItemCard>
				<div className='float-right'>
					<Tooltip title="Editar" onClick={() => setShowEditModal(true)}>
						<FontAwesomeIcon className='text-link' icon={faEdit} />
					</Tooltip>
					<Divider type="horizontal" className='my-5' />
					<Tooltip title="Eliminar" placement='bottom'>
						<Popconfirm
							title="Esta acción no se puede revertir"
							okText="Eliminar"
							cancelText="Cancelar"
							okButtonProps={{ danger:true }}
							onConfirm={handleDelete}
						>
							<FontAwesomeIcon className='text-link' icon={faTrash} />
						</Popconfirm>
					</Tooltip>
				</div>
				<p className='bold mb-3'>{reportDetail.detail_type.name}</p>
				<p className='mb-0 text-muted small'>
					{reportDetail.comment ? reportDetail.comment : <em>Sin detalle registrado</em>}
				</p>
				<p className='mb-0 text-muted small'>
					Resultado registrado el {reportDetail.created_at}
				</p>
			</ListItemCard>
			{ showEditModal && (
				<EditReportDetailModal 
					visible
					onClose={() => setShowEditModal(false)}
					reportDetail={reportDetail}
					reload={reload}
				/>
			)}
		</React.Fragment>
	)
}